import Ajax from "./ajax";
import config from "../config"

export default {
  install(Vue) {
    Vue.prototype.$http = Ajax;
    Vue.prototype.$config = config;
  }
}
